<template>
  <div id="app">
    <agile
      :nav-buttons="false"
      :autoplay-speed="3000"
      :speed="2500"
      :fade="true"
      :pause-on-hover="true"
      :pause-on-dots-hover="true"
      :autoplay="true"
    >
      <img
        v-for="(slide, index) in slides"
        :key="index"
        class="slide"
        :src="`${$baseURL}assets/${slide.directus_files_id.id}`"
      />
    </agile>
  </div>
</template>

<script>
import { VueAgile } from "vue-agile";

export default {
  name: "App",
  components: {
    agile: VueAgile,
  },
  props: ["slides"],
};
</script>

<style>
.agile__dots {
  bottom: 10px;
  flex-direction: column;
  right: 30px;
  position: absolute;
}

.agile__dot {
  margin: 5px 0;
}

.agile__dot button {
  background-color: transparent;
  border: 1px solid #fff;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  transition-duration: 0.3s;
  width: 10px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.5); /* Přidání stínu */
}

.agile__dot--current button,
.agile__dot:hover button {
  background-color: #fff;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.5); /* Přidání stínu */
}

.slide {
  display: block;
  height: 500px;
  object-fit: cover;
  width: 100%;
  border-radius: 24px;
}
</style>
